/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AdmissionEMContacts from './admission-em-contacts';
import AdmissionEMContactsDetail from './admission-em-contacts-detail';
import AdmissionEMContactsUpdate from './admission-em-contacts-update';
import AdmissionEMContactsDeleteDialog from './admission-em-contacts-delete-dialog';

const AdmissionEMContactsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AdmissionEMContacts />} />
    <Route path="new" element={<AdmissionEMContactsUpdate />} />
    <Route path=":id">
      <Route index element={<AdmissionEMContactsDetail />} />
      <Route path="edit" element={<AdmissionEMContactsUpdate />} />
      <Route path="delete" element={<AdmissionEMContactsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AdmissionEMContactsRoutes;
